import "./UwMedicalReview.scss";
import React from 'react';
import { useSelector } from "react-redux";
import ConfirmDialog from "../../../components/confirmDialog/confirmDialog.jsx";
import {
  CustomButton,
  CustomLoadingButton,
} from "../../../components/ui/CustomButton.jsx";
import newRequest from "../../../utils/newRequest.js";
import { showToast } from "../../../toastService.js";
import {
  DialogActions,
  Dialog,
  DialogTitle,
  DialogContent,
  Tooltip,
  Table,
  TableContainer,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Paper,
  TablePagination,
  Select,
  MenuItem
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import CloseIcon from "@mui/icons-material/Close";
import DeleteIcon from "@mui/icons-material/Delete";
import SearchIcon from "@mui/icons-material/Search";
import { motion } from "framer-motion";
import moment from "moment";
import { useEffect, useState } from "react";
import { FaSave } from "react-icons/fa";
import { MdRefresh } from "react-icons/md";
import { IoClose } from "react-icons/io5";
import { GridLoader, ScaleLoader } from "react-spinners";
import ExpandableComponent from "../../../components/expandableComponent/ExpandableComponent.jsx";
import { useTranslation } from "react-i18next";
import { customSelectStyles_dark, customSelectStyles_light } from "../../../components/ui/CustomSelect.jsx";
import ReactSelect from "react-select";

const UwMedicalReview = () => {
  const { t } = useTranslation();
  const { currentUser } = useSelector((state) => state.user);
  const { currentTheme } = useSelector((state) => state.theme);
  const [isProcessing, setIsProcessing] = useState(false);
  const [isConfirmDialogOpen, setIsConfirmDialogOpen] = useState(false);
  const [confirmDialogAction, setConfirmDialogAction] = useState("None");
  const [isNotifyDialogOpen, setIsNotifyDialogOpen] = useState(false);
  const [notifyDialogTitle, setNotifyDialogTitle] = useState("Confirm");
  const [notifyDialogText, setNotifyDialogText] = useState("Text");
  const [isLoading, setIsLoading] = useState(true);
  const [savingTitle, setSavingTitle] = useState("Save");
  const [medicalReviews, setMedicalReviews] = useState([]);
  const [selectedMedicalReview, setSelectedMedicalReview] = useState(null);
  const [reviewQuestions, setReviewQuestions] = useState([]);
  const [selectedQuestion, setSelectedQuestion] = useState(null);
  const [selectedSubQuestion, setSelectedSubQuestion] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [currentAction, setCurrentAction] = useState(null);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(0);
  const [testsToPerform, setTestsToPerform] = useState([]);
  const [isQstDialogOpened, setIsQstDialogOpened] = useState(false);
  const [qstRef, setQstRef] = useState(null);
  const [question, setQuestion] = useState(null);
  const [answerType, setAnswerType] = useState("string");
  const [ifYesDesc, setIfYesDesc] = useState(null);


  const handlePageChange = (event, newPage) => {
    setCurrentPage(newPage);
  };

  const [selectedTestToAdd, setSelectedTestToAdd] = useState(null);
  const [medicalTests, setMedicalTests] = useState([]);
  const fetchMedicalTests = async (sysType) => {
    try {
      const res = await newRequest.post(
        "/sysCode/findAll", { sys_type: "Medical Tests" });

      const options = res.data.map((codes) => ({
        value: codes?.sys_code,
        label: codes?.sys_name,
      }));

      setMedicalTests(options);

    } catch (error) {
      console.log(error);
    }
  };

  const handleAddTest = async () => {
    try {
      if (selectedTestToAdd) {
        const res = await newRequest.post(
          "/uwMedicalReview/addMedicalTest",
          {
            review_docid: selectedMedicalReview._id,
            test_code: selectedTestToAdd?.value
          }
        );
        if (res.data === "exists") {
          showToast(
            `Test ${selectedTestToAdd?.label} is already added`,
            "error"
          );
          setSelectedTestToAdd(null);
        } else {
          const newMtest = {
            test_code: selectedTestToAdd.value,
            test_desc: selectedTestToAdd.label
          };
          addTestToArray(newMtest)
          showToast(`Test ${selectedTestToAdd.label} added `, "success");
          setSelectedTestToAdd(null);
        }
      }

    } catch (error) {
      console.log(error);
    }
  };

  const handleRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setCurrentPage(0);
  };

  const handleAddQuestion = async () => {
    try {

      if (!qstRef) {
        setNotifyDialogTitle("Note!");
        setNotifyDialogText(`Please enter unique reference no!`);
        setIsNotifyDialogOpen(true);
        return;
      }
      if (!question) {
        setNotifyDialogTitle("Note!");
        setNotifyDialogText(`Please enter question!`);
        setIsNotifyDialogOpen(true);
        return;
      }

      if (!answerType) {
        setNotifyDialogTitle("Note!");
        setNotifyDialogText(`Please select expected answer type!`);
        setIsNotifyDialogOpen(true);
        return;
      }

      setIsProcessing(true);
      let res = null;

      if (currentAction === "addMainQst") {
        res = await newRequest.post(
          "/uwMedicalReview/addMainQst",
          {
            review_docid: selectedMedicalReview._id,
            qst_ref: qstRef,
            question: question,
            answer_type: answerType,
            if_yes_desc: ifYesDesc,
          }
        );
      } else if (currentAction === "addSubQst") {
        res = await newRequest.post(
          "/uwMedicalReview/addSubQst",
          {
            review_docid: selectedMedicalReview._id,
            main_qst_ref: selectedQuestion?.qst_ref,
            sub_qst_ref: qstRef,
            sub_question: question,
            sub_answer_type: answerType,
            sub_if_yes_desc: ifYesDesc,
          }
        );
      }


      if (res.data === "exists") {
        setIsProcessing(false);
        showToast(
          `Question with reference ${qstRef} already exists`,
          "error"
        );
      } else {

        if (currentAction === "addMainQst") {
          const newQuestion = {
            _id: res.data._id,
            qst_ref: qstRef,
            question: question,
            if_yes_desc: ifYesDesc,
            answer_type: answerType
          };
          addMainQuestionToArray(newQuestion)
        }

        setQstRef(null);
        setQuestion(null);
        setAnswerType("string");
        setIfYesDesc(null);
        setCurrentAction(null);
        setIsQstDialogOpened(false);
        setIsProcessing(false);
        showToast(
          `Question added`,
          "success"
        );
      }
    } catch (error) {
      setIsProcessing(false);
      console.log(error);
    }
  };

  const addMainQuestionToArray = async (newQuestion) => {
    try {
      const updatedQuestions = [...reviewQuestions, newQuestion];
      setReviewQuestions(updatedQuestions)
    } catch (error) {
      console.log(error);
    }
  };


  const addTestToArray = async (newTest) => {
    try {
      const updatedTests = [...testsToPerform, newTest];
      setTestsToPerform(updatedTests)
    } catch (error) {
      console.log(error);
    }
  };

  const addSubQuestionToArray = async (newQuestion) => {
    try {
      const updatedQuestions = [...reviewQuestions, newQuestion];
      setReviewQuestions(updatedQuestions)
    } catch (error) {
      console.log(error);
    }
  };

  const removeQuestionFromArray = async (qstRef) => {
    try {
      const updatedQuestions = reviewQuestions.filter(question => question.qst_ref !== qstRef);
      setReviewQuestions(updatedQuestions)
    } catch (error) {
      console.log(error);
    }
  };

  const removeMtestFromArray = async (testCode) => {
    try {
      const updatedTests = testsToPerform.filter(mt => mt.test_code !== testCode);
      setTestsToPerform(updatedTests)
    } catch (error) {
      console.log(error);
    }
  };



  const [objectToAction, setObjectToAction] = useState({
    object_id: "",
    action_text: "",
    action_invoked: "",
    param1: ""
  });

  const handleClearSearch = () => {
    try {
      setSearchTerm("");
    } catch (error) {
      console.log(error);
    }
  };

  const fetchReviews = async () => {
    try {
      setIsProcessing(true);
      const res = await newRequest.post("/uwMedicalReview/findAll", { mr_code: "" });
      // console.log(`fetchReviews  ${JSON.stringify(res.data, null, 2)}`);
      setMedicalReviews(res.data);
      setSelectedMedicalReview(res.data[0]);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setIsProcessing(false);
    }
  };


  useEffect(() => {
    setIsLoading(true);
    fetchReviews();
    fetchMedicalTests();
    setIsLoading(false);
  }, []);

  const filteredReviews = medicalReviews?.filter(
    (item) =>
      item.mr_code?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      item.mr_name?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  useEffect(() => {
    try {
      setReviewQuestions(selectedMedicalReview?.mr_questions);
      setTestsToPerform(selectedMedicalReview?.medical_tests_xx);
    } catch (error) {
      console.log(error);
    }
  }, [selectedMedicalReview]);


  const filteredQuestions = reviewQuestions?.filter(
    (item) =>
      item.qst_ref?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      item.question?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const slicedReviewQuestions = reviewQuestions?.slice(
    currentPage * rowsPerPage,
    currentPage * rowsPerPage + rowsPerPage
  );

  const handleQuestionChange = (e, rowId) => {
    try {
      const { name, value } = e.target;
      const updatedData = [...reviewQuestions];
      const rowIndex = updatedData.findIndex(item => item._id === rowId);

      if (rowIndex === -1) {
        console.log('row not found');
      }

      updatedData[rowIndex][name] = value;
      updatedData[rowIndex]["changed_xx"] = "Y";

      // console.log(`rowId is ${rowId} handleLimitChange updatedData  \n${JSON.stringify(updatedData, null, 2)}`);
      setReviewQuestions(updatedData);
    } catch (error) {
      console.log(error);
    }
  };


  const handleDelete = (rowId) => {
    try {

    } catch (error) {
      console.log(error);
    }
  };


  const handleConfirm = async () => {
    try {
      if (confirmDialogAction === "deleteMainQst") {
        setIsProcessing(true);
        const res = await newRequest.post("/uwMedicalReview/delMainQst", {
          review_docid: selectedMedicalReview._id,
          qst_ref: objectToAction.param1
        });

        if (res.data === "deleted") {
          removeQuestionFromArray(objectToAction.param1);
          setIsProcessing(false);
          showToast(
            `Question with reference ${objectToAction.param1} deleted`,
            "success"
          );
        } else {
          setIsProcessing(false);
          showToast(
            `Error deleting question with reference ${objectToAction.param1}`,
            "error"
          );
        }
      } else if (confirmDialogAction === "removeTest") {
        setIsProcessing(true);
        const res = await newRequest.post("/uwMedicalReview/deleteMedicalTest", {
          review_docid: selectedMedicalReview._id,
          test_code: objectToAction.param1
        });

        if (res.data === "deleted") {
          removeMtestFromArray(objectToAction.param1);
          setIsProcessing(false);
          showToast(
            `Test ${objectToAction.param1} removed`,
            "success"
          );
        } else {
          setIsProcessing(false);
          showToast(
            `Error removing test ${objectToAction.param1}`,
            "error"
          );
        }
      }

    } catch (err) {
      console.log(err);
    }
    // Close the dialog
    setIsConfirmDialogOpen(false);
  };

  const handleCancel = () => {
    setIsConfirmDialogOpen(false);
  };

  const handleCloseNotifyDialog = () => {
    setIsNotifyDialogOpen(false);
  };

  const saveRecord = async (e) => {
    // e.preventDefault();
    try {
      setSavingTitle("saving...");
      setIsProcessing(true);
      // Simulate delay for 5 seconds
      // await new Promise((resolve) => setTimeout(resolve, 5000));

      const changedQuestions = reviewQuestions.filter((obj) => obj?.changed_xx === "Y");

      // console.log(`changedQuestions  ${JSON.stringify(changedQuestions, null, 2)}`);

      for (let i = 0; i < changedQuestions?.length; i++) {
        const res = await newRequest.post(
          "/uwMedicalReview/updMainQst",
          {
            review_docid: selectedMedicalReview._id,
            qst_ref: changedQuestions[i].qst_ref,
            question: changedQuestions[i].question,
            answer_type: changedQuestions[i].answer_type,
            if_yes_desc: changedQuestions[i].if_yes_desc
          }
        );
      }

      showToast("Updated!", "success");
    } catch (err) {
      console.log(err);
    } finally {
      setSavingTitle("Save");
      setIsProcessing(false);
    }
  };

  return (
    <div className="uw-medical-review">
      {isLoading ? (
        <div className="no-content"
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            width: "100%",
            height: "100%",
          }}
        >
          <ScaleLoader
            color="var(--primary)"
            height={50}
            radius={8}
            width={4}
          />
        </div>
      ) : (
        <div className="review-main-wrapper">
          <div className="review-center-wrapper">
            <div className="center-details">
              <div className="center-navbar">
                <h1 className="main-title">
                  {selectedMedicalReview?.mr_name}
                </h1>
                <span
                  style={{ display: "flex", flexDirection: "row", gap: "5px" }}
                >
                  <CustomLoadingButton
                    currentTheme={currentTheme}
                    iconPosition="end"
                    borderRadiusType="left"
                    endIcon={<MdRefresh />}
                    onClick={fetchReviews}
                  >
                    Refresh
                  </CustomLoadingButton>
                  <CustomLoadingButton
                    currentTheme={currentTheme}
                    iconPosition="end"
                    borderRadiusType="right"
                    endIcon={<FaSave />}
                    onClick={saveRecord}
                  >
                    {savingTitle}
                  </CustomLoadingButton>
                </span>
              </div>
              <hr />
              <ExpandableComponent
                title="MEDICAL TESTS"
                subtitle={
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "center",
                      gap: "5px",
                    }}
                  >
                    <div className="input-item-with-label">
                      <label htmlFor="test_id">{t('test').toUpperCase()}</label>
                      <ReactSelect
                        id="test_id"
                        name="test_id"
                        menuPortalTarget={document.body}
                        styles={{
                          ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                          menuPortal: base => ({
                            ...base,
                            zIndex: 9999,
                          })
                        }}
                        width="300px"
                        value={selectedTestToAdd}
                        onChange={(selectedOption) => {
                          try {
                            setSelectedTestToAdd(selectedOption);
                          } catch (error) {
                            console.log(error);
                          }
                        }}
                        options={medicalTests}
                        isSearchable={true}
                        placeholder="Medical Tests"
                      />
                    </div>
                    <CustomLoadingButton
                      currentTheme={currentTheme}
                      iconPosition="end"
                      borderRadiusType="right"
                      endIcon={<AddIcon />}
                      onClick={handleAddTest}
                    >
                      {t('add')}
                    </CustomLoadingButton>
                  </div>
                }
                onSubtitleClick={() => { }}
                bgColor="#fff"
                defaultExpanded={true}
              >
                <div className="mtests-wrapper">
                  {testsToPerform?.length > 0 && (
                    <>
                      {testsToPerform?.map((row, index) => (
                        <div key={row._id} className="single-item">
                          <span
                            style={{
                              alignContent: "flex-start",
                              fontWeight: "bold",
                              fontSize: "20px",
                            }}
                          >
                            {index + 1}.
                          </span>
                          <div className="mtest">
                            <span className="mtest-name">
                              {row.test_desc}
                            </span>
                            <Tooltip
                              title={`Remove ${row.test_desc}`}
                              placement="right"
                            >
                              <IoClose
                                size={24}
                                style={{
                                  borderRadius: "5px",
                                  padding: "3px",
                                  cursor: "pointer",
                                  color: "rgba(172, 33, 9)",
                                  backgroundColor: "rgba(172, 33, 9, 0.5)",
                                }}
                                onClick={() => {
                                  try {
                                    const action_text = `Do you want to remove ${row.test_desc}?`;
                                    setObjectToAction({
                                      object_id: row._id,
                                      action_text: action_text,
                                      new_doc_status: "removeTest",
                                      param1: row.test_code
                                    });
                                    setConfirmDialogAction("removeTest");
                                    setIsConfirmDialogOpen(true);
                                  } catch (error) {
                                    console.log(error);
                                  }
                                }}
                              />
                            </Tooltip>
                          </div>
                        </div>
                      ))}
                    </>
                  )}
                </div>
              </ExpandableComponent>
              <ExpandableComponent
                title="INSURED QUESTIONNAIRE"
                subtitle={<CustomLoadingButton startIcon={<AddIcon />} onClick={() => { }}> Add Question </CustomLoadingButton>}
                onSubtitleClick={() => {
                  try {
                    setCurrentAction("addMainQst");
                    setIsQstDialogOpened(true);
                  } catch (error) {
                    console.log(error);
                  }
                }}
                bgColor="#fff"
                defaultExpanded={true}
              >
                <div className="table-content">
                  <TableContainer component={Paper} sx={{ border: 'none', boxShadow: 'none' }} className="table-container">
                    <Table sx={{ width: "max-content", border: 'none' }}>
                      <TableHead className="tablehead">
                        <TableRow className="tablerow">
                          <TableCell className="table-cell" style={{ maxWidth: "50px", fontWeight: "bold", display: "flex", textAlign: "center" }}>
                            #
                          </TableCell>
                          <TableCell className="table-cell" style={{ maxWidth: "80px" }}>
                            <span>REF</span>
                          </TableCell>
                          <TableCell className="table-cell" style={{ width: "auto" }}>
                            <span>NAME</span>
                          </TableCell>
                          <TableCell className="table-cell" style={{ maxWidth: "120px" }}>
                            <span>ANS TYPE</span>
                          </TableCell>
                          <TableCell className="table-cell" style={{ display: "flex", flexDirection: "row", gap: "5px", fontWeight: "bold", maxWidth: "150px", alignItems: "center", justifyContent: "center" }}>
                            <span>ACTION</span>
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody className="tablebody">
                        {slicedReviewQuestions?.map((row, index) => (
                          <React.Fragment key={row._id}>
                            <TableRow
                              className={`${selectedQuestion?._id === row._id ? "tablerow current" : "tablerow"}`}
                              onClick={() => {
                                try {
                                  setSelectedSubQuestion(null);
                                  setSelectedQuestion(row);
                                } catch (error) {
                                  console.log(error)
                                }
                              }}
                            >
                              <TableCell className="table-cell center" style={{ maxWidth: "50px" }}>
                                {currentPage * rowsPerPage + index + 1}
                              </TableCell>
                              <TableCell className="table-cell left" style={{ maxWidth: "80px" }}>
                                <div className="input-item-with-label">
                                  <input
                                    id="qst_ref"
                                    name="qst_ref"
                                    value={row.qst_ref}
                                    onChange={(e) => handleQuestionChange(e, row._id)}
                                    style={{ width: "100%" }}
                                    className="form-input-item table"
                                  />
                                </div>
                              </TableCell>
                              <TableCell className="table-cell left" style={{ width: "auto", gap: "5px" }}>
                                <div className="input-item-with-label" style={{ width: "100%" }}>
                                  <input
                                    id="question"
                                    name="question"
                                    value={row.question}
                                    onChange={(e) => handleQuestionChange(e, row._id)}
                                    style={{ width: "100%" }}
                                    className="form-input-item table"
                                  />
                                </div>
                                {row?.answer_type === "boolean" &&
                                  <div className="input-item-with-label" style={{ width: "100%" }}>
                                    <input
                                      id="if_yes_desc"
                                      name="if_yes_desc"
                                      value={row.if_yes_desc}
                                      onChange={(e) => handleQuestionChange(e, row._id)}
                                      placeholder="If yes, please explain"
                                      style={{ width: "100%" }}
                                      className="form-input-item table"
                                    />
                                  </div>}
                              </TableCell>
                              <TableCell className="table-cell left" style={{ maxWidth: "120px" }}>
                                <Select
                                  id="answer_type"
                                  name="answer_type"
                                  value={row.answer_type}
                                  onChange={(e) => handleQuestionChange(e, row._id)}
                                  variant="outlined"
                                  size="small"
                                >
                                  <MenuItem value="string">description</MenuItem>
                                  <MenuItem value="number">number</MenuItem>
                                  <MenuItem value="boolean">boolean</MenuItem>
                                  <MenuItem value="group">group</MenuItem>
                                </Select>
                              </TableCell>
                              <TableCell className="table-cell" style={{ display: "flex", flexDirection: "row", gap: "5px", fontWeight: "bold", maxWidth: "150px", alignItems: "center", justifyContent: "center" }}>
                                {row?.answer_type === "group" &&
                                  <Tooltip title={`Add Sub Questions to [${row.question}]`} placement="left">
                                    <AddIcon
                                      className="action-icon add"
                                      onClick={() => {
                                        try {
                                          setSelectedQuestion(row);
                                          setCurrentAction("addSubQst");
                                          setIsQstDialogOpened(true);
                                        } catch (error) {
                                          console.log(error);
                                        }
                                      }}
                                    />
                                  </Tooltip>}
                                <Tooltip title={`Delete ${row.question}?`} placement="left">
                                  <DeleteIcon
                                    className="action-icon del"
                                    onClick={() => {
                                      try {
                                        let action_text = `Delete ${row.question}?`;
                                        setObjectToAction({
                                          object_id: row._id,
                                          action_text: action_text,
                                          new_doc_status: "deleteMainQst",
                                          param1: row.qst_ref
                                        });
                                        setConfirmDialogAction("deleteMainQst");
                                        setIsConfirmDialogOpen(true);
                                      } catch (error) {
                                        console.log(error)
                                      }
                                    }}
                                  />
                                </Tooltip>
                              </TableCell>
                            </TableRow>
                            {/* Sub-table for group answer types */}
                            {row.answer_type === "group" && row?.sub_questions?.length > 0 && (
                              <TableRow style={{ display: "flex", width: "100%" }}>
                                <TableCell style={{ display: "flex", width: "100%" }}>
                                  <Table sx={{ display: "flex", flexDirection: "column", width: "100%" }}>
                                    <TableHead style={{ display: "flex", width: "100%" }}>
                                      <TableRow style={{ display: "flex", width: "100%" }}>
                                        <TableCell className="table-cell" style={{ flex: "1", maxWidth: "80px" }}>
                                          Ref
                                        </TableCell>
                                        <TableCell className="table-cell" style={{ flex: "1", flexGrow: 1, gap: "10px" }}>
                                          Question
                                        </TableCell>
                                        <TableCell className="table-cell" style={{ flex: "1", maxWidth: "120px" }}>
                                          Answer Type
                                        </TableCell>
                                        <TableCell className="table-cell" style={{ flex: "1", display: "flex", flexDirection: "row", gap: "5px", fontWeight: "bold", maxWidth: "150px", alignItems: "center", justifyContent: "center" }}>
                                          Action
                                        </TableCell>
                                      </TableRow>
                                    </TableHead>
                                    <TableBody style={{ display: "flex", flexDirection: "column", width: "100%" }}>
                                      {row.sub_questions.map((sub, subIndex) => (
                                        <TableRow key={sub._id}
                                          className={`${selectedSubQuestion?._id === sub._id ? "tablerow current" : "tablerow"}`}
                                          onClick={() => setSelectedSubQuestion(sub)}
                                        >
                                          <TableCell className="table-cell" style={{ flex: "1", maxWidth: "80px" }}>
                                            <div className="input-item-with-label">
                                              <input
                                                id="sub_qst_ref"
                                                name="sub_qst_ref"
                                                value={sub.qst_ref}
                                                onChange={(e) => handleQuestionChange(e, row._id)}
                                                style={{ width: "100%" }}
                                                className="form-input-item table"
                                              />
                                            </div>
                                          </TableCell>
                                          <TableCell className="table-cell" style={{ flex: "1", displayL: "flex", flexDirection: "column", gap: "3px", flexGrow: "1" }}>
                                            <div className="input-item-with-label">
                                              <input
                                                id="sub_question"
                                                name="sub_question"
                                                value={sub.question}
                                                onChange={(e) => handleQuestionChange(e, row._id)}
                                                style={{ width: "100%" }}
                                                className="form-input-item table"
                                              />
                                            </div>
                                            {sub?.answer_type === "boolean" &&
                                              <div className="input-item-with-label">
                                                <input
                                                  id="sub_if_yes_desc"
                                                  name="sub_if_yes_desc"
                                                  value={sub.if_yes_desc}
                                                  onChange={(e) => handleQuestionChange(e, row._id)}
                                                  placeholder="If yes, please explain"
                                                  style={{ width: "100%" }}
                                                  className="form-input-item table"
                                                />
                                              </div>}
                                          </TableCell>
                                          <TableCell className="table-cell" style={{ flex: "1", maxWidth: "120px" }}>
                                            <Select
                                              id="sub_answer_type"
                                              name="sub_answer_type"
                                              value={sub.answer_type}
                                              onChange={(e) => handleQuestionChange(e, sub._id)}
                                              variant="outlined"
                                              size="small"
                                            >
                                              <MenuItem value="string">description</MenuItem>
                                              <MenuItem value="number">number</MenuItem>
                                              <MenuItem value="boolean">boolean</MenuItem>
                                            </Select>
                                          </TableCell>
                                          <TableCell className="table-cell" style={{ flex: "1", display: "flex", flexDirection: "row", gap: "5px", fontWeight: "bold", maxWidth: "150px", alignItems: "center", justifyContent: "center" }}>
                                            <Tooltip title={`Delete ${sub.question}?`} placement="left">
                                              <DeleteIcon
                                                // className="action-icon"
                                                style={{
                                                  borderRadius: "5px",
                                                  padding: "3px",
                                                  alignSelf: "center",
                                                  cursor: "pointer",
                                                  color: "rgba(244, 67, 54)",
                                                  backgroundColor: "rgba(244, 67, 54, 0.5)",
                                                }}
                                                onClick={() => handleDelete(row._id)}
                                              />
                                            </Tooltip>
                                          </TableCell>
                                        </TableRow>
                                      ))}
                                    </TableBody>
                                  </Table>
                                </TableCell>
                              </TableRow>
                            )}
                          </React.Fragment>
                        ))}
                      </TableBody>
                    </Table>
                    <TablePagination
                      rowsPerPageOptions={[10]}
                      rowsPerPage={rowsPerPage}
                      onRowsPerPageChange={handleRowsPerPage}
                      component="div"
                      count={filteredQuestions?.length}
                      rows={filteredQuestions}
                      page={currentPage}
                      onPageChange={handlePageChange}
                    />
                  </TableContainer>
                </div>
              </ExpandableComponent>
            </div>
          </div>
          <div className="right-wrapper">
            <div className="right-content">
              <div className="right-navbar" >
                <div className="search-input-wrapper">
                  <SearchIcon className="search-input-icon" />
                  <input
                    className="search-input"
                    type="text"
                    placeholder="Search..."
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                  />
                  {searchTerm?.length > 0 && (
                    <CloseIcon
                      onClick={handleClearSearch}
                      className="search-input-icon"
                    />
                  )}
                </div>
              </div>
              <div className="options-list">
                <span
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    marginBottom: "10px",
                  }}
                >
                  <CustomButton
                    currentTheme={currentTheme}
                    iconPosition="end"
                    endIcon={<AddIcon />}
                    onClick={() => {
                      try {

                      } catch (error) {
                        console.log(error);
                      }
                    }}
                    width={"95%"}
                  >
                    ADD CLASS
                  </CustomButton>
                </span>
                {filteredReviews?.map((row) => (
                  <>
                    <span
                      key={row._id}
                      className={`${selectedMedicalReview._id === row._id
                        ? "single-option active"
                        : "single-option"
                        }`}
                      onClick={async () => {
                        try {
                          setSelectedMedicalReview(row);
                        } catch (error) {
                          console.log(error);
                        }
                      }}
                    >
                      <div className="title-row">
                        <span className="cy-title">{row.mr_name}</span>
                      </div>
                    </span>
                    <hr style={{ margin: "0px 10px" }} />
                  </>
                ))}
              </div>
            </div>
          </div>
        </div>
      )}
      {/* Dialog to notify user about changes being saved */}
      <Dialog open={isNotifyDialogOpen} onClose={handleCloseNotifyDialog}>
        <DialogTitle>{notifyDialogTitle}</DialogTitle>
        <DialogContent>
          <div dangerouslySetInnerHTML={{ __html: notifyDialogText }} />
        </DialogContent>
        <DialogActions>
          <CustomButton onClick={handleCloseNotifyDialog}>Close</CustomButton>
        </DialogActions>
      </Dialog>
      {/* Confirm Dialog */}
      <ConfirmDialog
        isOpen={isConfirmDialogOpen}
        onClose={handleCancel}
        onConfirm={handleConfirm}
        dialogTitle="Confirmation"
        dialogContent={<p>{objectToAction.action_text}</p>}
      />
      {isQstDialogOpened && (
        <motion.div
          className="overlay-dialog"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1, transition: { duration: 1 } }}
          exit={{ opacity: 0, transition: { duration: 1 } }}
        >
          <div className="overlay-wrapper">
            <div className="overlay-navbar">
              <span>ADD QUESTION</span>
              <span
                onClick={() => {
                  try {
                    setQstRef(null);
                    setQuestion(null);
                    setAnswerType("string");
                    setIfYesDesc(null);
                    setCurrentAction(null);
                    setIsQstDialogOpened(false);
                  } catch (error) {
                    console.log(error);
                  }
                }}
              >
                <IoClose
                  style={{
                    width: "30px",
                    height: "30px",
                    cursor: "pointer",
                    borderRadius: "50%",
                  }}
                />
              </span>
            </div>
            <div className="overlay-content">
              <div className="input-item-with-label">
                <label
                  htmlFor="qstRef"
                  className="form-dropdown-label"
                  style={{ width: "130px" }}
                >
                  REF
                </label>
                <input
                  id="qstRef"
                  name="qstRef"
                  type="text"
                  placeholder="NAME"
                  value={qstRef}
                  className="form-input-item"
                  style={{ width: "150px" }}
                  onChange={(e) => setQstRef(e.target.value)}
                />
              </div>
              <div className="input-item-with-label">
                <label
                  htmlFor="question"
                  className="form-dropdown-label"
                  style={{ width: "130px" }}
                >
                  QUESTION
                </label>
                <input
                  id="question"
                  name="question"
                  type="text"
                  placeholder="Question"
                  value={question}
                  rows={3}
                  className="form-input-item"
                  style={{ width: "400px" }}
                  onChange={(e) => setQuestion(e.target.value)}
                />
              </div>
              <div className="input-item-with-label">
                <label
                  htmlFor="answer_type"
                  className="form-dropdown-label"
                  style={{ width: "130px" }}
                >
                  ANSWER TYPE
                </label>
                <Select
                  id="sub_answer_type"
                  name="sub_answer_type"
                  value={answerType}
                  onChange={(e) => setAnswerType(e.target.value)}
                  variant="outlined"
                  style={{ width: "150px" }}
                  size="small"
                >
                  <MenuItem value="string">description</MenuItem>
                  <MenuItem value="number">number</MenuItem>
                  <MenuItem value="boolean">boolean</MenuItem>
                  <MenuItem value="group">group</MenuItem>
                </Select>
              </div>
            </div>
            <div className="overlay-actions">
              <CustomLoadingButton onClick={handleAddQuestion}>ADD</CustomLoadingButton>
            </div>
          </div>
        </motion.div>
      )}

      {isProcessing && (
        <motion.div
          className="processing-dialog"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1, transition: { duration: 1 } }}
          exit={{ opacity: 0, transition: { duration: 1 } }}
        >
          <div className="processing-wrapper">
            <GridLoader color="#bd97fc"
              style={{
                height: "50px",
                width: "50px",
              }}
            />
          </div>
        </motion.div>
      )}
    </div>
  );
};

export default UwMedicalReview;
